@if (shouldRenderHeader()) {
    <div class="d-flex justify-content-between align-content-center">
        <div>
            @if (hasVisibleHeaderTitle()) {
                <h4>
                    {{ form.header }}

                    @if (isLoading) {
                        <div class="reactive-form-header-spinner">
                            <p-progressSpinner
                                [style]="{ width: '20px', height: '20px' }"
                                strokeWidth="6"
                                animationDuration="1.5s">
                            </p-progressSpinner>
                        </div>
                    }
                </h4>
            }
        </div>

        <div class="form-header-actions">
            @for (button of headerButtons; track $index) {
                <button
                    [class]="button.class ?? 'btn btn-primary'"
                    [style]="button.style"
                    (click)="headerButtonClick.emit(button)"
                    type="button">
                    @if (button.icon) {
                        <i [class]="button.icon" aria-hidden="true"></i>
                    }
                    <span>{{ button.label }}</span>
                </button>
            }

            @for (uploadButton of getUploadButtons(); track trackUploadButton($index, uploadButton)) {
                <app-reactive-upload-images
                    [formModel]="model.getRawValue()"
                    [buttonLabel]="uploadButton.label"
                    [imageFolder]="getUploadFolder(uploadButton)"
                    [formType]="form.type"
                    [imageDisplay]="getUploadDisplay(uploadButton)"
                    [imageName]="getUploadFieldName(uploadButton)"
                    [accept]="getUploadAccept(uploadButton)"
                    [allowedExtensions]="uploadButton.allowedExtensions ?? null"
                    [invalidFormatMessage]="uploadButton.invalidFormatMessage ?? ''"
                    [uploadUrl]="uploadButton.uploadUrl ?? null"
                    [viewFolder]="uploadButton.viewFolder ?? null"
                    [showPreview]="uploadButton.showPreview ?? true"
                    [maxFileSizeBytes]="uploadButton.maxFileSizeBytes ?? null"
                    [uploadId]="getUploadId(uploadButton)"
                    (sendImageName)="onImageNameChange($event, uploadButton)">
                </app-reactive-upload-images>
            }
        </div>
    </div>
}
